import Vue from 'vue'
import Router from 'vue-router'
var title = "启芯领航"

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: resolve => require(['@/pages/index/index'], resolve),
    beforeEnter: (to, from, next) => {
      document.getElementById("mainTitle").innerHTML = title+"-首页"
      next()
    }
  },{
    path: '/index',
    name: 'index',
    component: resolve => require(['@/pages/index/index'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-首页"
        next()
    } 
  },{
    path: '/product',
    name: 'product',
    component: resolve => require(['@/pages/product/index'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-产品"
        next()
    } 
  },{
    path: '/productList',
    name: 'productList',
    component: resolve => require(['@/pages/productList/index'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-产品列表"
        next()
    } 
  },{
    path: '/about',
    name: 'about',
    component: resolve => require(['@/pages/about/index'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-关于我们"
        next()
    } 
  },{
    path: '/zhao',
    name: 'zhao',
    component: resolve => require(['@/pages/zhao/index'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-加入我们"
        next()
    } 
  },{
    path: '/news',
    name: 'news',
    component: resolve => require(['@/pages/news/index'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-新闻中心"
        next()
    } 
  },{
    path: '/detail',
    name: 'detail',
    component: resolve => require(['@/pages/detail/index'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-新闻详情"
        next()
    } 
  },{
    path: '/service',
    name: 'service',
    component: resolve => require(['@/pages/service/index'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-服务支持"
        next()
    } 
  }],
  mode:'history'   //去除#号
})



// WEBPACK FOOTER //
// ./src/router/index.js